import React, { useEffect, useState } from "react";
import { employeeService } from "api";
import moment from "moment";
import { Button, Col, Row, Space } from "antd";
import { formatToCurrencyType } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import RenderTemplate from "components/common/DocxTemplate/RenderTemplate";

interface FormTempaltesProps {
  hdId: string | number;
  closeModal?: () => void;
}
export default function FormTemplates({
  hdId,
  closeModal,
}: FormTempaltesProps) {
  const [HDTV, setHDTV] = useState({});
  useEffect(() => {
    if (hdId) {
      getDataHDTV();
    }
  }, [hdId]);
  function removeDiacritics(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');
  }
  const displayOptData = (data) => {
    return data || "...............";
  };
  const getDataHDTV = async () => {
    const res = await employeeService.getTemplateTMNV(hdId as string | number);
    const { hop_dong = {}, nhan_vien = {} } = res.data.data;
    const {
      ngay_nhan_viec,
      thoi_gian_thu_viec,
      ngay_lam_moi_tuan,
      gio_lam_moi_ngay,
      vi_tri_ung_tuyen,
    } = hop_dong;
    const {
      cccd_cmnd,
      ngay_cap_cccd,
      ngay_sinh,
      noi_cap_cccd,
      dia_chi_thuong_tru,
      dien_thoai,
      ho_ten,
      tong_thu_nhap,
      nghe_nghiep_TA,
      noi_cap_ta,
      dia_chi_lam_viec,
      dia_chi_lam_viec_ta
    } = nhan_vien;
    setHDTV({
      ngay_nhan_viec: moment(ngay_nhan_viec).format(FORMAT_TIME.dayFull) ?? "",
      thoi_gian_thu_viec: thoi_gian_thu_viec ?? "",
      tong_thu_nhap: formatToCurrencyType(tong_thu_nhap) ?? "",
      ngay_lam_moi_tuan: ngay_lam_moi_tuan ?? "",
      gio_lam_moi_ngay:displayOptData(gio_lam_moi_ngay) ?? "",
      ngay_cap_cccd: moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull) ?? "",
      ngay_sinh: moment(ngay_sinh).format(FORMAT_TIME.dayFull) ?? "",
      noi_cap_cccd: noi_cap_cccd ?? "",
      cccd_cmnd:cccd_cmnd ?? "",
      vi_tri_ung_tuyen: vi_tri_ung_tuyen ?? "",
      dia_chi_thuong_tru:dia_chi_thuong_tru ?? "",
      dia_chi_thuong_tru_ta:removeDiacritics(dia_chi_thuong_tru) ?? "",
      dien_thoai:dien_thoai ?? "",
      ho_ten,
      ho_ten_khong_dau: removeDiacritics(ho_ten) ?? "",
      vi_tri_ung_tuyen_ta:nghe_nghiep_TA ?? "",
      noi_cap_ta:noi_cap_ta ?? "",
      dia_chi_lam_viec:dia_chi_lam_viec?? "",
      dia_chi_lam_viec_ta:removeDiacritics(dia_chi_lam_viec_ta) ?? "",
    });
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <RenderTemplate
          data={HDTV}
          templatePath="/files/ThuMoiNhanViec.docx"
          outputName="Mẫu in thư mời nhận việc.docx"
          label="Mẫu in thư mời nhận việc"
        />
      </Row>

      <Row justify="end" style={{ marginTop: 12 }}>
        <Col>
          <Space>
            <Button
              onClick={closeModal}
              style={{
                backgroundColor: "red",
                borderColor: "red",
                color: "white",
              }}
            >
              Đóng
            </Button>
          </Space>{" "}
        </Col>
      </Row>
    </div>
  );
}
